<template>
  <div id="invoice" class="w-100 h-100 f-s-s">
    <div class="invoice f-s-s f-d-c">
      <div class="title f-c-c w-100">
        پیش فاکتور
        <span class="title-name f-c-c">{{
          "(" + invoiceData.title + ")"
        }}</span>

        <div class="return">
          <div class="f-c-s returnBtn" @click="returnFunc()">
            <div class="returnText f-c-c">برگشت</div>
          </div>
        </div>
      </div>
      <div class="invoiceTable f-c-s f-d-c w-100 mb-5">
        <div class="header f-c-s w-100">
          <div class="headerItem f-c-s"></div>
          <div class="headerItem f-c-s">موضوع</div>
          <div class="headerItem f-c-s">
            مبلغ
            <!-- <span>(تومان)</span> -->
          </div>
          <div class="headerItem f-c-s">توضیحات</div>
          <div class="headerItem f-c-s"></div>
        </div>
        <div class="tableContent f-c-s f-d-c w-100">
          <div
            class="tableRow f-c-s w-100"
            v-for="(v, i) in invoiceData.items"
            :key="i"
          >
            <div class="tableItem f-c-c">{{ i + 1 }}</div>
            <div class="tableItem f-c-s">
              <div
                :title="v.title"
                class="f-c-s w-90"
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ v.title }}
              </div>
            </div>
            <div class="tableItem f-c-s">{{ v.price }}</div>
            <div class="tableItem f-c-s">
              <div
                :title="v.note"
                class="f-c-s w-90"
                style="
                  white-space: nowrap;
                  overflow: hidden;
                  text-overflow: ellipsis;
                "
              >
                {{ v.note }}
              </div>
            </div>
            <div class="tableItem f-c-c">
              <div
                class="deleteBtn f-c-c"
                @click.prevent="deleteInvoiceFunc(v)"
              >
                حذف
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <div class="discount w-100 f-c-s">
        <div class="dis-title f-c-s">کد تخفیف</div>
        <div v-if="invoiceData.voucher" class="discount-title f-c-c ml-4">
          {{ invoiceData.voucher }}
        </div>
        <input
          v-if="!invoiceData.voucher"
          v-model="discount"
          type="text"
          class="discount-input f-c-c ml-4"
          :class="[discount ? 'discount-input-active' : '']"
        />
        <div
          v-if="invoiceData.voucher"
          class="discount-delete f-c-c"
          @click="discountDelete()"
        >
          حذف
        </div>
        <div
          v-if="!invoiceData.voucher"
          class="discount-set f-c-c"
          @click.prevent="discountSet()"
          :class="[discount ? 'discount-set-active' : '']"
        >
          ثبت
        </div>
      </div> -->
      <div class="w-100 total f-c-s">
        <div class="total-title f-c-s">مجموع</div>
        <div class="total-price f-c-e">{{ invoiceData.total_price }}</div>
        <!-- <div class="total-unit f-c-c">تومان</div> -->
      </div>
      <div class="w-100 total f-c-s">
        <div class="total-title f-c-s">تخفیف</div>
        <div class="total-price f-c-e">
          {{ invoiceData.off_price ? invoiceData.off_price : 0 }}
        </div>
        <!-- <div class="total-unit f-c-c">تومان</div> -->
      </div>
      <div class="w-100 total f-c-s">
        <div class="total-title f-c-s">قابل پرداخت</div>
        <div class="total-price f-c-e">
          {{ invoiceData.payable_price }}
        </div>
        <!-- <div class="total-unit f-c-c">تومان</div> -->
      </div>
      <div class="w-100 total f-c-s mb-5">
        <div class="total-title f-c-s">اعتبار شما</div>
        <div class="total-price f-c-e">{{ invoiceData.your_credit }}</div>
        <!-- <div class="total-unit f-c-c">تومان</div> -->
      </div>
      <div class="createSession f-c-c w-100">
        <div
          v-if="invoiceData.error"
          class="notValidity animate__animated animate__headShake animate__delay-1s"
        >
          {{ "«" + invoiceData.error + "»" }}
        </div>
        <div v-else>
          <div v-if="isSetSession" class="inactive">در حال ارسال ...</div>
          <div v-else class="validity" @click="createSessionFunc()">ساخت جلسه</div>
        </div>
      </div>
    </div>
    <DeleteConfirm v-if="isDelete" message="از حذف مطمئن هستید ؟" />
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
import DeleteConfirm from "@/components/DelConfirmModal";
import { EventBus } from "@/assistant/EventBus";
export default {
  name: "Invoice",
  data() {
    return {
      discount: "",
      isValidity: false,
      isDelete: false,
      isDiscountDel: false,
      isSetSession: false,
      invoiceDeleted: {},
      invoiceData: {},
    };
  },
  components: {
    DeleteConfirm,
  },
  created() {
    EventBus.$on("deleteItem", (status) => {
      if (status) {
        if (this.invoiceDeleted.type == "sans") {
          this.deleteTempSansFunction({
            user_id: this.user.user_id,
            temp_session_sans_id: this.invoiceDeleted.sans_id,
          });
        } else if (this.invoiceDeleted.type == "support_request") {
          this.deleteTempFunction({
            type: "del/temp_support_request",
            user_id: this.user.user_id,
            temp_session_id: this.invoiceData.session_id,
          });
        } else if (this.invoiceDeleted.type == "record") {
          this.deleteTempFunction({
            type: "del/temp_record",
            user_id: this.user.user_id,
            temp_session_id: this.invoiceData.session_id,
          });
        } else if (this.isDiscountDel) {
          this.deleteTempFunction({
            type: "del/temp_voucher",
            user_id: this.user.user_id,
            temp_session_id: this.invoiceData.session_id,
          });
          this.discount = "";
        }
      }
      this.isDelete = false;
      this.isDiscountDel = false;
      this.invoiceDeleted = {};
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      setSissionStatus: (state) => state.gap.setSissionStatus,
      setDiscountStatus: (state) => state.gap.setDiscountStatus,
      newInvoiceData: (state) => state.gap.newInvoiceData,
      createSessionStatus: (state) => state.gap.createSessionStatus,
    }),
  },
  methods: {
    ...mapActions("gap", [
      "setDiscountFunction",
      "deleteTempFunction",
      "deleteTempSansFunction",
      "setNewInvoiceDataFunction",
      "setSessionStep1DataFunction",
      "setSessionStep2DataFunction",
      "setSessionStep3DataFunction",
      "createSessionFunction",
    ]),
    returnFunc() {
      this.$router.push({ name: "addNewSission3" });
    },
    deleteInvoiceFunc(v) {
      this.isDelete = true;
      this.invoiceDeleted = v;
    },
    discountDelete() {
      this.isDelete = true;
      this.isDiscountDel = true;
    },
    discountSet() {
      if (this.discount) {
        this.setDiscountFunction({
          user_id: this.user.user_id,
          temp_session_id: this.invoiceData.session_id,
          voucher: this.discount,
        });
      }
    },
    createSessionFunc() {
      this.isSetSession = true;
      this.createSessionFunction({
        user_id: this.user.user_id,
        temp_session_id: this.invoiceData.session_id,
      });
    },
  },
  watch: {
    createSessionStatus(n) {
      if (Object.keys(n).length) {
        this.isSetSession = false;
        if (n.code == 100) {
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
          this.setSessionStep1DataFunction({});
          this.setSessionStep2DataFunction({
            users: [],
            guest: false,
          });
          this.setSessionStep3DataFunction({});
          setTimeout(() => {
            this.$router.push({ name: "myMeets" });
          }, 800);
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    setSissionStatus(n) {
      if (Object.keys(n).length) {
        if (n.code == 100 && n.error !== "failed") {
          this.invoiceData = n;
          this.setNewInvoiceDataFunction(n);
          this.$bvToast.toast(n.message, {
            title: "تایید",
            variant: "success",
            solid: true,
          });
        } else if (n.code == 100 && n.error === "failed") {
          this.setSessionStep1DataFunction({});
          this.setSessionStep2DataFunction({
            users: [],
            guest: false,
          });
          this.setSessionStep3DataFunction({});
          this.$router.push({ name: "myMeets" });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
  },
  mounted() {
    this.invoiceData = this.setSissionStatus;
  },
};
</script>